import { Component, OnInit, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../service/user.service';
import { EmployeeService } from '../../service/employee.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { OnboardingService } from '../../service/onboarding.service';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { CadreDialog } from '../cadre-dialog/cadre-dialog.component';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDateFormats,
} from "@angular/material/core";
import { BasicEmployeeDetails } from '../../models/basicemployeedetails.model';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: 'app-group-id-confirm-dialog',
  templateUrl: './group-id-confirm-dialog.component.html',
  styleUrls: ['./group-id-confirm-dialog.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class GroupIdConfirmDialogComponent implements OnInit {
  GroupForm: FormGroup;
  error: any;
  type: string;
  groupId: string;
  secondaryEmail: string;
  dob: Date;
  maxDate: any;
  employeeDetails: BasicEmployeeDetails[];
  nonWhitespaceRegExp: RegExp = new RegExp("\\S");

  constructor(private toastr: ToastrService, private userService: UserService, public dialogRef: MatDialogRef<GroupIdConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string, private _service: EmployeeService, private formBuilder: FormBuilder, private hrSvc: OnboardingService) {
    this.GroupForm = this.formBuilder.group({
      Type: [null, [Validators.required, Validators.pattern(this.nonWhitespaceRegExp)]],
      GroupId: [null],
      SecondaryEmail: new FormControl("", [
        Validators.email,
        this.emailDomain,
        Validators.pattern(
          "[a-zA-Z0-9!#$%&amp;'*+/=?^_`{|}~.-]+@[a-zA-Z]+(.[a-z]+)*"
        ),
      ]),
      DOB: new FormControl(),
    });
  }

  ngOnInit() {
    this.getAllEmployees();
    this.GroupForm.get('Type').valueChanges.subscribe((value) => {
      if (value === 'Re-hire') {
        this.GroupForm.get('SecondaryEmail').setValidators([Validators.required, this.emailDomain]);
      } else {
        this.GroupForm.get('SecondaryEmail').clearValidators();
      }
      this.GroupForm.get('SecondaryEmail').updateValueAndValidity();
    });
  }

  emailDomain(control: AbstractControl): { [key: string]: any } | null {
    if (control.value != null) {
      const SecondaryEmail: string = control.value;
      const domain = SecondaryEmail.substring(
        SecondaryEmail.lastIndexOf("@") + 1
      );
      if (SecondaryEmail === "" || domain.toLowerCase() === "winwire.com") {
        return { emailDomain: true };
      } else {
        return null;
      }
    }
  }

  setDOB() {
      var dob = new Date();
      dob.setFullYear(dob.getFullYear() - 18);
      this.maxDate = dob;
    return this.maxDate;
  }

  get f() { return this.GroupForm.controls; }

  async getAllEmployees() {
    try {
      const data: BasicEmployeeDetails[] = await this._service.getAllEmployees().toPromise();
      this.employeeDetails = data || [];
    } catch (error) {
      this.error = error;
    }
  }

  setType() {
    var groupId = this.GroupForm.get('GroupId');
    var secondaryEmail = this.GroupForm.get('SecondaryEmail');
    var dob = this.GroupForm.get('DOB');
    if (this.type == 'Re-hire') {
      this.groupId = "WW";
    }
    else {
      this.groupId = null;
      this.secondaryEmail = null;
      this.dob = null;
      groupId.clearValidators();
      secondaryEmail.clearValidators();
      dob.clearValidators();
      groupId.updateValueAndValidity();
      secondaryEmail.updateValueAndValidity();
      dob.updateValueAndValidity();
    }
  }

  async onConfirm() {
    await this.getAllEmployees();
    if (!this.GroupForm.invalid) {
      if (this.type == 'Re-hire' && this.data == 'hremployee') {
        var details = this.employeeDetails != null && this.employeeDetails.length > 0 ? this.employeeDetails.filter(emp => {
              return (
                emp.GroupId === this.groupId &&
                new Date(emp.DOB).getTime() === new Date(this.dob).getTime() &&
                emp.SecondaryEmail === this.secondaryEmail
          );
        }).pop() : undefined;
        if (details == undefined)
          alert("email/DOB entered is not matching with the details under GroupID " + this.groupId)
        else if (details != undefined) {
          const isH1Migrated = details.IsMigratedOnH1;
          const isValidDateOfExit = isH1Migrated ? details.US_DOE != null : details.DateOfExit != null;
          if (isValidDateOfExit) {
            this.dialogRef.close({ event: true, type: this.type, groupId: this.groupId, dob: new Date(this.dob), secondaryEmail: this.secondaryEmail })
          }
          else {
            alert("Date of exit is Blank for the earlier record/s");
          }
        }
        else
              this.dialogRef.close({ event: true, type: this.type, groupId: this.groupId, dob: new Date(this.dob), secondaryEmail: this.secondaryEmail })

      }
      else
        this.dialogRef.close({ event: true, type: this.type, groupId: this.groupId, dob: new Date(this.dob), secondaryEmail:this.secondaryEmail })
    }
    else {
      const controls = this.GroupForm.controls;

      for (const controlName in controls) {
        if (controls[controlName].invalid) {
          // console.log(`${controlName} is invalid`);
        }
      }
      return;
    }

  }

  onKeyPress(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (!value.startsWith('WW')) {
      input.value = 'WW';
      this.groupId = input.value;
      return;
    }
    if (value.length < 2) {
      if (event.key !== 'W') {
        event.preventDefault();
      }
    }
    if (value.length > 2) {
      const numericPart = value.slice(2);
      const filteredNumericPart = numericPart.replace(/\D/g, '');
      input.value = 'WW' + filteredNumericPart.slice(0, 6);
    }
    if (value.length >= 8) {
      event.preventDefault();
    }
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close({ event: false });
  }
}
